// Presentation metadata for lead outcomes (labels come from i18n WASAPI_CAPI.OUTCOMES.<KEY>).
export const OUTCOME_META = {
  qualified_lead: { icon: 'i-lucide-user-check', color: 'blue' },
  sold: { icon: 'i-lucide-badge-check', color: 'teal' },
  order_canceled: { icon: 'i-lucide-package-x', color: 'amber' },
  not_sold: { icon: 'i-lucide-x-circle', color: 'slate' },
  contact: { icon: 'i-lucide-phone', color: 'blue' },
  schedule: { icon: 'i-lucide-calendar-check', color: 'blue' },
  lead: { icon: 'i-lucide-user-plus', color: 'blue' },
  complete_registration: { icon: 'i-lucide-clipboard-check', color: 'blue' },
  submit_application: { icon: 'i-lucide-file-check', color: 'blue' },
  subscribe: { icon: 'i-lucide-bell-ring', color: 'teal' },
  start_trial: { icon: 'i-lucide-flask-conical', color: 'teal' },
  initiate_checkout: { icon: 'i-lucide-shopping-cart', color: 'amber' },
  add_to_cart: { icon: 'i-lucide-shopping-basket', color: 'amber' },
  view_content: { icon: 'i-lucide-eye', color: 'slate' },
};

export const outcomeMeta = key =>
  OUTCOME_META[key] || { icon: 'i-lucide-flag', color: 'slate' };

export const outcomeLabelKey = key =>
  `WASAPI_CAPI.OUTCOMES.${String(key).toUpperCase()}`;
